import { makeInitialOpgavekompleksetTaskEntry } from './util.make-initial-task-entry.js';
import { parseLegacyDetailItem } from './tasks/_inputs.js';

function postProcessOpgavekompleksetEntry(entry, component) {
  if (component.state !== "valid") {
    throw new Error("postProcessEntry(): Unable to process invalid component");
  }
  const processedEntry = structuredClone(entry);

  //
  // STEP: Convert all legacy details for tasks into our new format
  //
  for (const [taskId, entry] of Object.entries(processedEntry.tasks)) {
    const potentiallyLegacyDetails = entry.details;
    if (Array.isArray(potentiallyLegacyDetails)) {
      const relatedTask = component.data.tasks.find(it => it.type === "task" && it.id === taskId);
      if (!relatedTask) {
        throw new Error("postProcessOpgavekompleksetEntry(): Unable to resolve related task");
      }
      const relatedInputs = relatedTask.content.filter(it => it.nodeType !== "html" && it.nodeType !== "text");
      entry.details = Object.fromEntries(potentiallyLegacyDetails.flatMap((item, index) => {
        const relatedInput = relatedInputs[index];
        const result = parseLegacyDetailItem(item, {
          relatedTask,
          relatedInput,
          indexInDetails: index
        });
        if (typeof result?.[0] === "string") {
          return [result];
        } else {
          return result;
        }
      }).filter(it => !!it));
    } else if (potentiallyLegacyDetails.__legacyStack) {
      const stacks = component.data.tasks.filter(it => it.type === "stack");
      const legacyTaskDetails = potentiallyLegacyDetails.tasks;
      entry.details = Object.fromEntries(Object.entries(legacyTaskDetails).flatMap(([taskId, {
        details
      }]) => {
        const relatedTask = stacks.flatMap(it => it.tasks).find(it => it.id === taskId);
        if (!relatedTask) {
          throw new Error("postProcessOpgavekompleksetEntry(): Unable to resolve related task");
        }
        const relatedInputs = relatedTask.content.filter(it => it.nodeType !== "html" && it.nodeType !== "text");
        return details.flatMap((item, j) => {
          const relatedInput = relatedInputs[j];
          const result = parseLegacyDetailItem(item, {
            relatedTask,
            relatedInput,
            indexInDetails: j
          });
          if (typeof result?.[0] === "string") {
            return [result];
          } else {
            return result;
          }
        }).filter(it => !!it);
      }));
    }
  }

  //
  // STEP: populate the entry with all tasks present in the component. However,
  // if the user should progress conditionally, then omit this step, as all
  // tasks shouldn't be present in the results screen.
  //
  if (component.data.settings.flowType !== "conditional") {
    for (const task of component.data.tasks) {
      if (!processedEntry.tasks[task.id]) {
        processedEntry.tasks[task.id] = makeInitialOpgavekompleksetTaskEntry(component.data, task.id);
      }
    }
  }
  return processedEntry;
}

export { postProcessOpgavekompleksetEntry };
//# sourceMappingURL=processor.post-entry.js.map
